import { isRequestedFrom } from 'utils/localisation';
import { usaRegion, ukRegion, germanRegion, arabicRegion } from 'define/locale';
import {
  dachPriorities,
  dePriorities,
  usPriorities,
  ukPriorities,
  menaPriorities,
  industriesPriority,
  industriesPriorityDe,
} from '../constants';
import { distinct } from 'utils';

export function getOptions(projects, filters, lang) {
  const filteredIndustries = filters.industries.map(industry => industry.value);
  const filteredCountries = filters.countries.map(contry => contry.value);

  const getIndustryOptions = () => {
    if (filteredCountries.length > 0) {
      const industries = distinct(
        projects
          .filter(project => filteredCountries.includes(project.country))
          .map(({ industry }) => industry)
          .filter(Boolean),
      ).sort();
      return prioritizeIndustries(industries);
    }

    const industries = distinct(projects.map(({ industry }) => industry).filter(Boolean)).sort();
    return prioritizeIndustries(industries);
  };

  const prioritizeIndustries = industries => {
    const priorities = lang === 'de' ? industriesPriorityDe : industriesPriority;

    const industriesWithPriority = priorities
      .filter(({ industry }) => industries.includes(industry))
      .sort((a, b) => a.priority - b.priority)
      .map(({ industry }) => industry);

    return [...new Set([...industriesWithPriority, ...industries])];
  };

  const getCoutryOptions = () => {
    if (filteredIndustries.length > 0) {
      const filteredByIndustry = projects.filter(project =>
        filteredIndustries.includes(project.industry),
      );

      return sortCountries(filteredByIndustry);
    }

    return sortCountries(projects);
  };

  const sortCountries = projectsArr => {
    if (typeof window !== 'undefined') {
      const countries = Object.entries(
        projectsArr.reduce((acc, { country }) => {
          if (!country) {
            return acc;
          }
          if (!acc[country]) {
            acc[country] = 1;
          } else {
            acc[country] += 1;
          }
          return acc;
        }, {}),
      )
        .toSorted((a, b) => b[1] - a[1])
        .map(item => item[0]);

      if (lang === 'de') {
        return prioritizeCountries(countries, dePriorities);
      }
      if (isRequestedFrom(germanRegion)) {
        return prioritizeCountries(countries, dachPriorities);
      }
      if (isRequestedFrom(usaRegion)) {
        return prioritizeCountries(countries, usPriorities);
      }
      if (isRequestedFrom(ukRegion)) {
        return prioritizeCountries(countries, ukPriorities);
      }
      if (isRequestedFrom(arabicRegion)) {
        return prioritizeCountries(countries, menaPriorities);
      }

      return countries;
    }
    return [];
  };

  const prioritizeCountries = (countries, priorities) => {
    if (priorities) {
      const countriesWithPriority = priorities
        .filter(({ country }) => countries.includes(country))
        .sort((a, b) => a.priority - b.priority)
        .map(({ country }) => country);

      return [...new Set([...countriesWithPriority, ...countries])];
    }

    return countries;
  };

  return {
    industries: {
      values: getIndustryOptions(),
      titleKey: 'industry',
    },
    countries: {
      values: getCoutryOptions(),
      titleKey: 'location',
      withSearch: true,
    },
  };
}
